import { combineReducers } from 'redux';

import lists from './lists';
import ux from './ux';

export default combineReducers({
  lists,
  ux,
});
